import React from 'react';
import ProductDetailCalendarCustom from './ProductDetailCalendarCustom';
import * as Cart from 'rev.sdk.js/Actions/Cart';
import * as AppActions from '../AppActions';
import * as JStorage from 'rev.sdk.js/Actions/JStorage';
import * as Ant from 'antd';
import {useOutlet} from 'reconnect.js';
import {LocaleDictionary} from '../constants/custom';

const L = AppActions.L;
const F = AppActions.F;
const U = AppActions.U;

// seasonbakery custom
const yesterday = new Date();
yesterday.setDate(yesterday.getDate() - 1);

export function checkLogisticDisabled({logistics_type, variants, currConfig}) {
  for (let v of variants) {
    const field = v.name;

    if (v.type === 'single') {
      const value = (currConfig.variants || []).find((c) => c.name === field);
      const choice = (v.choices || []).find((c) => c.name === value?.choice);

      if ((choice?.exclude_logistics || []).includes(logistics_type)) {
        return {variant: v, choice};
      }
    }
  }
}

export default function CustomProductDetailSectionD(props) {
  const {product, setValues, values, currItemConfig, onNextConfig} = props;
  const [records, setRecords] = React.useState([]);
  const [YM, setYM] = React.useState({
    year: new Date().getFullYear(),
    month: new Date().getMonth(),
  });
  const [locale] = useOutlet('locale');

  const logisticDisabledReason = checkLogisticDisabled({
    logistics_type: values?.logistics_type,
    variants: product.variants,
    currConfig: currItemConfig,
  });

  const getRecords = React.useCallback(async () => {
    if (product?.id && values?.logistics_type) {
      AppActions.setLoading(true);
      const start = new Date(YM.year, YM.month, 1);
      const end = new Date(YM.year, YM.month + 1, 0);
      let availableDates = [];
      const bookingOffsetDates =
        product?.booking_offset > 0
          ? Array.from(Array(product.booking_offset).keys()).map((i) => {
              const d = new Date();
              d.setDate(d.getDate() + i);
              return d.toLocaleDateString('sv');
            })
          : [];

      try {
        let resp = await JStorage.fetchAllDocuments('product_calendar', {
          product: product?.id,
          date: {
            $gte: start.toLocaleDateString('sv'),
            $lte: end.toLocaleDateString('sv'),
          },
          logistic_type: values?.logistics_type,
        });
        availableDates = resp.filter(
          (x) => !bookingOffsetDates.includes(x.date),
        );
      } catch (e) {
        console.log(e);
      }
      setRecords(availableDates);
      AppActions.setLoading(false);
    }
  }, [product?.id, YM, values?.logistics_type, product?.booking_offset]);

  const calc = async (value) => {
    AppActions.setLoading(true);
    try {
      const extra_data = {
        ...values,
        ...value,
      };

      const itemConfig = {...currItemConfig, extraConfigs: extra_data};

      const resp = await Cart.calcPrice(product.id, itemConfig);
      const extra = {
        original_price:
          !product.original_price || !product.price
            ? resp.amount
            : Math.round(
                product.original_price * (resp.amount / product.price),
              ),
      };
      setValues(extra_data);

      onNextConfig(itemConfig, resp, extra);
    } catch (error) {
      console.warn(error);
      Ant.message.error('發生錯誤');
    }
    AppActions.setLoading(false);
  };

  React.useEffect(() => {
    getRecords();
  }, [getRecords]);

  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          flexDirection: 'column',
        }}>
        <label>{L('logistics_type')}</label>
        <Ant.Select
          value={values?.logistics_type}
          onChange={(value) => calc({logistics_type: value, date: null})}
          style={{width: 300}}
          status={logisticDisabledReason ? 'error' : ''}
          placeholder={L('please_select') + L('logistics_type')}>
          <Ant.Select.Option
            value="SELF_PICK"
            disabled={checkLogisticDisabled({
              logistics_type: 'SELF_PICK',
              variants: product.variants,
              currConfig: currItemConfig,
            })}>
            {U(LocaleDictionary.logistics_type.SELF_PICK)}
          </Ant.Select.Option>
          <Ant.Select.Option
            value="HOME"
            disabled={checkLogisticDisabled({
              logistics_type: 'HOME',
              variants: product.variants,
              currConfig: currItemConfig,
            })}>
            {U(LocaleDictionary.logistics_type.HOME)}
          </Ant.Select.Option>
        </Ant.Select>
        {logisticDisabledReason && (
          <div style={{color: 'var(--errorColor)'}}>
            {F(logisticDisabledReason.variant, 'label')}{' '}
            {F(logisticDisabledReason.choice, 'label')}{' '}
            {L('not_support_logsitic')}
          </div>
        )}
        {values?.logistics_type === 'HOME' && (
          <div style={{marginBottom: 20, color: 'var(--text-3-color)'}}>
            {L('reminder')}：
            {locale.lang === 'tw'
              ? '宅配訂購數量限制 1 份'
              : 'Quantity limit 1 unit by Home Delivery'}
          </div>
        )}
      </div>
      <div style={{height: 20}}></div>
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          flexDirection: 'column',
        }}>
        <label>{L('eta')}</label>
        <ProductDetailCalendarCustom
          size={300}
          selectedDts={records.map((x) => new Date(x.date))} // parse to Date, available dates
          selectedDt={values?.date ? new Date(values.date) : null} // parse to Date
          minDate={yesterday}
          setSelectedDt={(value) =>
            calc({date: value.toLocaleDateString('sv')})
          }
          onClickPrev={setYM}
          onClickNext={setYM}
        />
      </div>
    </div>
  );
}
